<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box pa-4">
            <div class="text-h6 font-weight-bold text-center mb-4">Link Rooms</div>

            <div class="mb-6">
                <table class="simple-exam-table">
                    <thead>
                        <tr>
                            <th>Exam Plan</th>
                            <th>Academic Year</th>
                            <th>Semester</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Exam Conduct Type</th>
                            <th>Stream</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ schedule_data.exam_name || '-' }}</td>
                            <td>{{ schedule_data.academic_year || '-' }}</td>
                            <td>{{ schedule_data.semester || '-' }}</td>
                            <td>{{ schedule_data.start_date || '-' }}</td>
                            <td>{{ schedule_data.end_date || '-' }}</td>
                            <td>{{ formatList(schedule_data.exam_conduct_types) }}</td>
                            <td>{{ formatList(schedule_data.streams) }}</td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr>
                            <th>Standard</th>
                            <th>Session No</th>
                            <th>Exam Date</th>
                            <th>Day</th>
                            <th>Slot No</th>
                            <th>From Time</th>
                            <th>To Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ formatStandards(schedule_data.standards) }}</td>
                            <td>{{ schedule_data.session_number || '-' }}</td>
                            <td>{{ formatDate(schedule_data.exam_date) }}</td>
                            <td>{{ schedule_data.day || '-' }}</td>
                            <td>{{ schedule_data.slot_no || '-' }}</td>
                            <td>{{ schedule_data.from_time || '-' }}</td>
                            <td>{{ schedule_data.to_time || '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="text-center mb-6">
                <div class="text-subtitle-2 font-weight-medium grey--text text--dark-1 mb-2">
                    Already Offered Rooms:
                </div>
                
                <div v-if="getSelectedRoomNames.length" class="d-flex flex-wrap justify-center align-center">
                    <v-chip
                        v-for="(name, index) in getSelectedRoomNames"
                        :key="index"
                        outlined
                        color="primary"
                        small
                        class="ma-1 font-weight-medium"
                    >
                        {{ name }}
                    </v-chip>
                </div>
                <div v-else class="text-caption grey--text">
                    No rooms offered
                </div>
            </div>

            <div class="text-center my-4">
                <span class="text-h6 font-weight-bold section-title">Select Rooms</span>
            </div>

            <v-container class="px-6 my-2">
                <v-row justify="center" align="center">
                    <v-col
                        v-for="room in master_rooms"
                        :key="room.id"
                        cols="12"
                        sm="3"
                        md="2"
                        class="py-1 d-flex justify-center"
                    >
                        <v-checkbox
                            v-model="selected_rooms"
                            :label="room.room_name"
                            :value="room.id"
                            dense
                            hide-details
                            class="mt-0"
                        ></v-checkbox>
                    </v-col>
                </v-row>

                <div v-if="!master_rooms.length" class="text-center grey--text my-4">
                    No rooms available for this schedule.
                </div>
            </v-container>

            <div class="d-flex justify-center align-center mt-6">
                <v-btn color="primary" class="px-6" @click="saveRoomSchedule">
                    Save
                </v-btn>
            </div>
        </v-card>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data: () => ({
        detailed_schedule_id: null,
        overlay: false,
        snackbar: false,
        snackbar_msg: "",
        color: "",

        schedule_data: {},
        master_rooms: [],
        selected_rooms: []
    }),

    computed: {
        getSelectedRoomNames() {
            return this.master_rooms
                .filter(room => this.selected_rooms.includes(room.id))
                .map(room => room.room_name);
        }
    },

    methods: {
        formatDate(dateStr) {
            if (!dateStr) return "-";
            const date = new Date(dateStr);
            return isNaN(date.getTime())
                ? dateStr
                : date.toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric"
                  });
        },

        formatList(arr) {
            if (!arr || !arr.length) return "-";
            return arr
                .map(item => (typeof item === "object" ? item.name : item))
                .filter(Boolean)
                .join(", ");
        },

        formatStandards(arr) {
            if (!arr || !arr.length) return "-";
            return arr
                .map(item => (typeof item === "object" ? item.standard : item))
                .filter(Boolean)
                .join(", ");
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        onLoad() {
            if (!this.detailed_schedule_id) {
                this.showSnackbar("#b71c1c", "Detailed Schedule ID not found");
                return;
            }

            this.overlay = true;
            axios
                .post("/SeatingArrangement/getRoomScheduleDetails", {
                    detailed_schedule_id: Number(this.detailed_schedule_id)
                })
                .then(res => {
                    if (res.data.msg === "200") {
                        this.schedule_data = res.data.schedule_data || {};
                        this.master_rooms = res.data.master_rooms || [];
                        this.selected_rooms = res.data.selected_room_ids || [];
                    } else {
                        this.showSnackbar(
                            "#b71c1c",
                            res.data.text || "Failed to fetch room schedule details"
                        );
                    }
                })
                .catch(error => {
                    console.error("Fetch Error:", error);
                    this.showSnackbar("#b71c1c", "Error fetching room schedule details");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        saveRoomSchedule() {
            if (!this.detailed_schedule_id) {
                this.showSnackbar("#b71c1c", "Detailed Schedule ID not found");
                return;
            }

            this.overlay = true;
            const payload = {
                detailed_schedule_id: Number(this.detailed_schedule_id),
                room_ids: this.selected_rooms
            };

            axios
                .post("/SeatingArrangement/saveRoomSchedule", payload)
                .then(res => {
                    if (res.data.msg === "200") {
                        this.showSnackbar(
                            "#2e7d32",
                            res.data.text || "Rooms linked successfully"
                        );
                        this.onLoad();
                    } else {
                        this.showSnackbar(
                            "#b71c1c",
                            res.data.text || "Failed to link rooms"
                        );
                    }
                })
                .catch(error => {
                    console.error("Save Error:", error);
                    this.showSnackbar("#b71c1c", "Error saving room schedule");
                })
                .finally(() => {
                    this.overlay = false;
                });
        }
    },

    mounted() {
        this.detailed_schedule_id = localStorage.getItem("detailed_schedule_id");
        this.onLoad();
    }
};
</script>

<style scoped>
.simple-exam-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #ffffff;
    text-align: center;
    border: 1px solid #dcdcdc;
}

.simple-exam-table th {
    background-color: #f2f2f2;
    color: #333333;
    font-weight: 600;
    font-size: 13px;
    padding: 8px;
    border: 1px solid #dcdcdc;
}

.simple-exam-table td {
    padding: 8px;
    font-size: 13px;
    color: #444444;
    border: 1px solid #dcdcdc;
}

.section-title {
    border-bottom: 2px solid #1976d2;
    padding-bottom: 4px;
}
</style>